import { useParams, useLocation, Navigate } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { FadeUp } from "@/components/Motion";
import { LEGAL_PAGES } from "@/data/legal";

export default function Legal() {
  const params = useParams();
  const location = useLocation();
  const { lang } = useI18n();

  // Derive slug from either /:slug param or the URL path itself
  const slug = params.slug || location.pathname.replace(/^\//, "").split("/")[0];
  const page = LEGAL_PAGES[slug];

  if (!page) return <Navigate to="/" replace />;

  const title = page.title[lang] || page.title.en;
  const sections = page.sections[lang] || page.sections.en;

  return (
    <div className="pt-32 pb-32 min-h-screen bg-black" data-testid={`legal-page-${slug}`}>
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <FadeUp>
          <div className="font-display text-[10px] tracking-[0.45em] text-gold mb-6">/ LEGAL</div>
          <h1 className="font-editorial italic font-light text-4xl lg:text-6xl text-cream leading-tight mb-16">
            {title}
          </h1>
        </FadeUp>

        <div className="space-y-12">
          {sections.map((s, i) => (
            <FadeUp key={i} delay={0.05 * i}>
              <h2 className="font-display text-[11px] tracking-[0.35em] text-gold mb-4 uppercase">
                {s.h}
              </h2>
              <div
                className="text-cream/75 font-body text-base leading-[1.85]"
                dangerouslySetInnerHTML={{ __html: s.p }}
              />
            </FadeUp>
          ))}
        </div>

        <FadeUp className="mt-24 pt-10 border-t border-white/10 text-center">
          <p className="text-xs text-cream/40 font-body">
            © {new Date().getFullYear()} Madubau · Juri Bauer · Gorneggweg 4A, 39040 Laion (BZ), Italy
          </p>
        </FadeUp>
      </div>
    </div>
  );
}
